import type { SerializedHardwarePackage } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { DeleteHardwarePackageArg } from 'lib/services/hardwarePackagesApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useDeleteHardwarePackage = ({
  onSuccess,
}: Pick<
  MutationOptions<SerializedHardwarePackage, unknown, DeleteHardwarePackageArg>,
  'onSuccess'
> = {}): UseMutationResult<SerializedHardwarePackage, unknown, DeleteHardwarePackageArg> => {
  const { hardwarePackagesApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: DeleteHardwarePackageArg) => await hardwarePackagesApiClient.delete(arg), {
    mutationKey: MUTATION_KEYS.hardwarePackages.deleteOne(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while deleting hardware package',
        description: getErrorMessage(error),
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Hardware package deleted`,
      });
      onSuccess?.(data, variables, context);
    },
  });
};
